function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M769 534.975L359.2 935.5a51.45 51.45 0 01-71.575 0l-47.8-46.7a48.675 48.675 0 01-.075-69.875L564.5 500 239.75 181.075a48.675 48.675 0 01.075-69.875l47.8-46.7a51.45 51.45 0 0171.575 0L769 465c19.75 19.325 19.75 50.625 0 69.95z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(550)",
  strokeWidth: "40",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M170 720h230M170 820h230M170 920h230"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "100",
  cy: "720",
  r: "15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "100",
  cy: "820",
  r: "15"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "100",
  cy: "920",
  r: "15"
}))));